import React, { useEffect, useState } from 'react';
import { AiOutlinePlus } from "react-icons/ai";
import { BiMinus } from "react-icons/bi";
import { MdDeleteForever } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { detrimentQNT, incrementQNT, removeItem } from '../../features/cartProducts/cartSlice';

const ProductItem = ({ product }) => {
    const { name, price, cardImg, prvPrice, quantity, total, _id } = product;

    const dispatch = useDispatch();

    const handleIncrementQNT = () => {
        dispatch(incrementQNT(product))
    }
    const handleDetrimentQNT = () => {
        dispatch(detrimentQNT(product))
    }
    const handleRemove = () => {
        dispatch(removeItem(product))
    }

    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    return (
        <div className="text-md font-normal text-gray-600 grid grid-cols-10 content-center justify-center px-3  py-4 border-b md:gap-0 gap-4">
            <div className="md:col-span-5 col-span-10 grid grid-cols-5">
                <div className='col-span-1'>
                    <div className='w-full grid justify-start'>
                        <img className='w-12' src={cardImg} alt="" />
                    </div>
                </div>
                <div className='md:px-2 px-0 h-full col-span-3  md:mb-0 mb-3'>
                    <div className='h-full grid content-center'>
                        <Link to={`/products/${_id}`} className="text-link">
                            <p className=''>{name.length > 32 ? name.substring(32, 0) + ".." : name}</p>
                        </Link>
                    </div>
                </div>
                <div className='md:pt-3 md:col-span-1 col-span-1'>
                    <div className="md:flex flex  md:space-x-2 space-x-0 w-full justify-end">
                        <div>
                            <p className='text-redbnd line-through'>{Number(price) < Number(prvPrice) && (prvPrice + `${translate ? "BDT": "টাকা"}`)}</p>
                            <p className=''>{price} {translate ? "BDT": "টাকা"}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="md:col-span-5 col-span-10 grid grid-cols-5">
                <div className='md:col-span-2 col-span-2 grid md:content-center select-none'>
                    <div className='input-arrw-none w-full grid content-center md:justify-center justify-start'>
                        <div className="flex flex-wrap items-stretch w-24 relative">
                            <div className="flex -mr-px">
                                <span onClick={handleDetrimentQNT} className="w-6 hover:bg-bnd-1 hover:text-white cursor-pointer duration-300 grid content-center justify-center leading-normal bg-grey-lighter rounded-l border border-r-0 px-1 border-grey-light whitespace-no-wrap">
                                    <BiMinus className='text-xm' />
                                </span>
                            </div>
                            <input type="number" value={quantity} className="font-poppins font-medium outline-none bg-gray-100 flex-shrink flex-grow leading-normal w-px border h-9 border-grey-light text-center relative" />
                            <div className="flex -mr-px">
                                <span onClick={handleIncrementQNT} className="w-6 hover:bg-bnd-1 hover:text-white cursor-pointer duration-300 grid content-center justify-center leading-normal bg-grey-lighter rounded-r border border-l-0 border-grey-light px-2 whitespace-no-wrap">
                                    <AiOutlinePlus className='text-sm' />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='md:col-2 col-span-1 grid content-center'>
                    <MdDeleteForever onClick={handleRemove} className='text-3xl bg-red-500 rounded text-white p-1 cursor-pointer' />
                </div>
                <div className='md:col-2 col-span-2 text-right grid content-end'>
                    <p className="w-full text-end"> {total} {translate ? "BDT": "টাকা"}</p>
                </div>
            </div>
        </div>
    );
};

export default ProductItem;